import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _obj;
/* import __COLOCATED_TEMPLATE__ from './date-time-input.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { action, computed } from "@ember/object";
import TEMPLATE from "./date-time-input.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend((_dec = computed("timezone"), (_obj = {
  classNames: ["d-date-time-input"],
  date: null,
  relativeDate: null,
  showTime: true,
  clearable: false,
  hours: computed("date", "showTime", function () {
    return this.date && this.get("showTime") ? this.date.hours() : null;
  }),
  minutes: computed("date", "showTime", function () {
    return this.date && this.get("showTime") ? this.date.minutes() : null;
  }),
  onClear() {
    this.onChange(null);
  },
  onChangeTime(time) {
    if (this.onChange) {
      const date = this.date ? this.date : this.relativeDate ? this.relativeDate : moment.tz(this.resolvedTimezone);
      this.onChange(moment.tz({
        year: date.year(),
        month: date.month(),
        day: date.date(),
        hours: time.hours,
        minutes: time.minutes
      }, this.resolvedTimezone));
    }
  },
  onChangeDate(date) {
    if (!date) {
      this.onClear();
      return;
    }
    this.onChange?.(moment.tz({
      year: date.year(),
      month: date.month(),
      day: date.date(),
      hours: this.hours || 0,
      minutes: this.minutes || 0
    }, this.resolvedTimezone));
  },
  get resolvedTimezone() {
    return this.timezone || moment.tz.guess();
  }
}, (_applyDecoratedDescriptor(_obj, "onClear", [action], Object.getOwnPropertyDescriptor(_obj, "onClear"), _obj), _applyDecoratedDescriptor(_obj, "onChangeTime", [action], Object.getOwnPropertyDescriptor(_obj, "onChangeTime"), _obj), _applyDecoratedDescriptor(_obj, "onChangeDate", [action], Object.getOwnPropertyDescriptor(_obj, "onChangeDate"), _obj), _applyDecoratedDescriptor(_obj, "resolvedTimezone", [_dec], Object.getOwnPropertyDescriptor(_obj, "resolvedTimezone"), _obj)), _obj))));